import script from "./ConfirmInterestPaymentPopUp.vue?vue&type=script&setup=true&lang=ts"
export * from "./ConfirmInterestPaymentPopUp.vue?vue&type=script&setup=true&lang=ts"

import "./ConfirmInterestPaymentPopUp.vue?vue&type=style&index=0&id=2c1847d0&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-2c1847d0"]])

export default __exports__